import React from 'react';
import { IS_MODERN_SSR } from '@atlassian/jira-conditional-ssr/src/constants.tsx';
import { Banner as BannerMain } from './main.tsx';

export function Banner() {
	if (!__SERVER__ || IS_MODERN_SSR) {
		return <BannerMain />;
	}

	return null;
}
